'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_Segments$StatsSection(eyebrow, title, items) {
  this.iC = null;
  this.iE = null;
  this.iD = null;
  this.iC = eyebrow;
  this.iE = title;
  this.iD = items;
}
export { $c_Lio_intela_sites_digitalinternship_data_Segments$StatsSection as $c_Lio_intela_sites_digitalinternship_data_Segments$StatsSection };
$p = $c_Lio_intela_sites_digitalinternship_data_Segments$StatsSection.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_Segments$StatsSection;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_Segments$StatsSection() {
}
export { $h_Lio_intela_sites_digitalinternship_data_Segments$StatsSection as $h_Lio_intela_sites_digitalinternship_data_Segments$StatsSection };
$h_Lio_intela_sites_digitalinternship_data_Segments$StatsSection.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, 1844450761, true);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_Segments$StatsSection)) {
    if (((this.iC === x$0.iC) && (this.iE === x$0.iE))) {
      var x = this.iD;
      var x$2 = x$0.iD;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 3;
});
$p.I = (function() {
  return "StatsSection";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.iC;
      break;
    }
    case 1: {
      return this.iE;
      break;
    }
    case 2: {
      return this.iD;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$StatsSection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bK)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$StatsSection as $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$StatsSection };
var $d_Lio_intela_sites_digitalinternship_data_Segments$StatsSection = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_Segments$StatsSection, "io.intela.sites.digitalinternship.data.Segments$StatsSection", ({
  bK: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_Segments$StatsSection as $d_Lio_intela_sites_digitalinternship_data_Segments$StatsSection };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Segments$-Stats-Section.js.map
